import { useTranslation } from 'react-i18next'
import { AddCounterparty } from '~/features/Counterparties/AddCounterparty'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'

const breadcrumbs: BreadcrumbsList = [
  { titleI18n: 'counterparties', link: '/counterparties' },
  { titleI18n: 'create counterparty' },
]

export const AddCounterpartyPage = () => {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('create counterparty')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>{t('create counterparty')}</PageTitle>
      </Container>
      <AddCounterparty />
    </PageContainer>
  )
}
